import { FormikErrors } from 'formik';
import { isNil, omitBy } from 'lodash';
import {
  applyAll,
  birthNumberInvalid,
  empty,
  hasAlphanumericChars,
  hasSpaces,
  maxLength,
  minLength,
  noDigitsAllow,
  notEmail,
  notPhoneNumber,
  notSafeName,
  restrictDiacriticsChars,
  restrictSpecialChars,
  tooShort,
} from 'utils/validations';
import { PersonalDetailsFormValues } from './PersonalDetailsFormValues';

export default function validatePersonalDetailsForm(
  values: PersonalDetailsFormValues,
) {
  const errors: FormikErrors<PersonalDetailsFormValues> = {};

  errors.firstName = applyAll(
    empty,
    notSafeName,
    noDigitsAllow,
    tooShort,
  )(values.firstName);
  errors.lastName = applyAll(
    empty,
    notSafeName,
    noDigitsAllow,
    tooShort,
  )(values.lastName);
  errors.mobilePhone = applyAll(
    empty,
    notPhoneNumber,
  )(values.mobilePhone.replace(/ /g, '').replace('+420', ''));
  errors.personalId = birthNumberInvalid(values.personalId);

  errors.email = applyAll(empty, notEmail)(values.email);
  errors.password = applyAll(
    empty,
    hasAlphanumericChars(),
    hasSpaces,
    maxLength(30),
    minLength(7),
    restrictSpecialChars,
    restrictDiacriticsChars,
  )(values.password);
  errors.acceptAgreement = empty(values.acceptAgreement);
  errors.acceptProfiling = empty(values.acceptProfiling);
  errors.acceptFaceIdProcessing = empty(values.acceptFaceIdProcessing);

  return omitBy(errors, isNil);
}
